
import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const NewsPage = () => {
  const { id } = useParams();
  const [language, setLanguage] = useState('fr');

  const newsData = {
    fr: {
      title: 'Actualités de Rouen',
      backToHome: 'Retour à l\'accueil',
      readMore: 'Lire plus d\'actualités',
      shareArticle: 'Partager l\'article',
      relatedNews: 'Actualités similaires',
      publishedOn: 'Publié le',
      by: 'par',
      articles: {
        '1': {
          title: 'Ouverture du nouveau centre culturel maghrébin à Rouen',
          date: '15 Décembre 2024',
          author: 'Équipe Wald Bladi',
          category: 'Culture',
          image: 'https://public.readdy.ai/ai/img_res/0f81c5dc679978d035350ed683dccbcc.jpg',
          excerpt: 'Un nouveau centre culturel dédié à la communauté maghrébine ouvre ses portes dans le quartier de la Rive Gauche.',
          content: `
            <p>La communauté maghrébine de Rouen célèbre aujourd'hui l'ouverture tant attendue du nouveau centre culturel situé au cœur du quartier de la Rive Gauche. Ce projet, porté par l'association Wald Bladi depuis plus de deux ans, représente un véritable lieu de rassemblement et d'échange pour toute la communauté.</p>
            
            <h3>Un espace polyvalent au service de la communauté</h3>
            <p>Le centre, d'une superficie de 500 m², propose de nombreux espaces dédiés aux activités culturelles, éducatives et sociales. On y trouve notamment :</p>
            <ul>
              <li>Une salle de conférence de 100 places</li>
              <li>Trois salles de cours pour l'apprentissage de l'arabe</li>
              <li>Un espace bibliothèque avec plus de 1000 ouvrages</li>
              <li>Une cuisine communautaire pour les événements</li>
              <li>Un salon de thé traditionnel</li>
            </ul>
            
            <h3>Des activités variées pour tous les âges</h3>
            <p>Le programme d'activités du centre est riche et diversifié. Les enfants pourront participer à des cours d'arabe, de calligraphie et de musique traditionnelle. Les adultes auront accès à des formations professionnelles, des cours de français et des ateliers d'insertion.</p>
            
            <p>Le centre organise également des événements culturels réguliers : soirées poésie, concerts de musique arabo-andalouse, expositions d'art contemporain maghrébin et conférences sur l'histoire et la culture du Maghreb.</p>
            
            <h3>Un projet financé par la solidarité</h3>
            <p>Ce projet a pu voir le jour grâce à la mobilisation exceptionnelle de la communauté. Plus de 200 familles ont contribué au financement, et de nombreux bénévoles ont participé aux travaux d'aménagement.</p>
            
            <p>La Ville de Rouen et la Région Normandie ont également apporté leur soutien financier, reconnaissant l'importance de ce projet pour le vivre-ensemble et l'intégration.</p>
            
            <h3>Horaires et inscriptions</h3>
            <p>Le centre est ouvert du lundi au samedi de 9h à 22h, et le dimanche de 14h à 20h. Les inscriptions aux différentes activités sont ouvertes dès maintenant à l'accueil du centre ou sur notre plateforme Wald Bladi.</p>
          `
        },
        '2': {
          title: 'Programme de formation professionnelle pour la communauté',
          date: '12 Décembre 2024',
          author: 'Service Formation',
          category: 'Formation',
          image: 'https://readdy.ai/api/search-image?query=Professional%20training%20classroom%20with%20diverse%20North%20African%20students%20learning%20computer%20skills%2C%20modern%20equipment%2C%20instructor%20teaching%2C%20bright%20educational%20environment%2C%20realistic%20photography&width=800&height=400&seq=news2&orientation=landscape',
          excerpt: 'Lancement d\'un nouveau programme de formation aux métiers du numérique spécialement conçu pour notre communauté.',
          content: `
            <p>Dans le cadre de notre mission d'accompagnement vers l'emploi, Wald Bladi lance un ambitieux programme de formation professionnelle aux métiers du numérique. Cette initiative vise à répondre aux besoins croissants du marché de l'emploi local tout en valorisant les compétences de notre communauté.</p>
            
            <h3>Des formations adaptées aux besoins du marché</h3>
            <p>Le programme propose quatre parcours de formation :</p>
            <ul>
              <li><strong>Développement web</strong> : HTML, CSS, JavaScript, React (6 mois)</li>
              <li><strong>Maintenance informatique</strong> : Réparation et assemblage PC (3 mois)</li>
              <li><strong>Commerce en ligne</strong> : E-commerce, réseaux sociaux (4 mois)</li>
              <li><strong>Bureautique avancée</strong> : Office, comptabilité (2 mois)</li>
            </ul>
            
            <h3>Un accompagnement personnalisé</h3>
            <p>Chaque participant bénéficie d'un suivi individualisé avec un conseiller dédié. L'équipe pédagogique, composée de professionnels expérimentés issus de la communauté, assure un enseignement de qualité dans un environnement bienveillant.</p>
            
            <p>Les cours sont dispensés en français avec possibilité de traduction en arabe pour faciliter la compréhension des concepts techniques complexes.</p>
            
            <h3>Partenariats avec les entreprises locales</h3>
            <p>Nous avons noué des partenariats avec plus de 30 entreprises rouennaises qui s'engagent à recruter nos stagiaires. Ces entreprises participent également à l'élaboration des programmes pour garantir leur adéquation avec les besoins réels du marché.</p>
            
            <h3>Modalités d'inscription</h3>
            <p>Les formations sont gratuites et ouvertes à tous les membres de la communauté âgés de 18 à 55 ans. Les inscriptions se font sur entretien de motivation et test de niveau. Prochaine session d'inscription : 8 janvier 2025.</p>
          `
        },
        '3': {
          title: 'Marché solidaire hebdomadaire : un succès grandissant',
          date: '10 Décembre 2024',
          author: 'Comité d\'organisation',
          category: 'Solidarité',
          image: 'https://readdy.ai/api/search-image?query=Vibrant%20weekly%20market%20with%20North%20African%20vendors%20selling%20traditional%20foods%2C%20spices%2C%20crafts%2C%20families%20shopping%20together%2C%20colorful%20stalls%2C%20community%20atmosphere%2C%20Rouen%20France%2C%20realistic%20photography&width=800&height=400&seq=news3&orientation=landscape',
          excerpt: 'Le marché solidaire du samedi attire de plus en plus de familles et renforce les liens communautaires.',
          content: `
            <p>Depuis son lancement il y a six mois, le marché solidaire hebdomadaire organisé par Wald Bladi connaît un succès croissant. Chaque samedi matin, la place du Vieux-Marché se transforme en un véritable carrefour d'échanges et de solidarité pour notre communauté.</p>
            
            <h3>Plus qu'un marché, un lieu de vie</h3>
            <p>Le marché solidaire rassemble aujourd'hui plus de 40 stands tenus par des familles de la communauté. On y trouve :</p>
            <ul>
              <li>Produits alimentaires traditionnels du Maghreb</li>
              <li>Épices et condiments importés directement</li>
              <li>Artisanat traditionnel (poterie, textile, bijoux)</li>
              <li>Produits de beauté naturels</li>
              <li>Services de réparation et couture</li>
            </ul>
            
            <h3>Un système d'entraide unique</h3>
            <p>Le marché fonctionne selon un principe de solidarité : 20% des bénéfices sont reversés à un fonds commun qui aide les familles en difficulté. Ce système permet de soutenir concrètement les membres de la communauté tout en valorisant l'entrepreneuriat local.</p>
            
            <p>De plus, un système de troc a été mis en place : les familles peuvent échanger des services contre des produits, renforçant ainsi les liens d'entraide.</p>
            
            <h3>Impact économique et social</h3>
            <p>En six mois, le marché a généré plus de 50 000€ de chiffre d'affaires pour les vendeurs, permettant à de nombreuses familles d'améliorer leur situation financière. Plus de 15 micro-entreprises ont été créées grâce à cette initiative.</p>
            
            <p>Au-delà de l'aspect économique, le marché est devenu un véritable lieu de socialisation où se tissent de nouvelles amitiés et se renforcent les liens intergénérationnels.</p>
            
            <h3>Projets d'extension</h3>
            <p>Face au succès rencontré, nous étudions la possibilité d'organiser un second marché en semaine et d'étendre l'initiative à d'autres quartiers de Rouen. Un marché spécialisé dans les produits bio et équitables est également à l'étude.</p>
          `
        }
      }
    },
    ar: {
      title: 'أخبار روان',
      backToHome: 'العودة للرئيسية',
      readMore: 'قراءة المزيد من الأخبار',
      shareArticle: 'مشاركة المقال',
      relatedNews: 'أخبار مشابهة',
      publishedOn: 'نُشر في',
      by: 'بواسطة',
      articles: {
        '1': {
          title: 'افتتاح المركز الثقافي المغاربي الجديد في روان',
          date: '15 ديسمبر 2024',
          author: 'فريق ولد بلادي',
          category: 'ثقافة',
          image: 'https://readdy.ai/api/search-image?query=Modern%20Moroccan%20cultural%20center%20building%20in%20Rouen%20France%20with%20traditional%20Islamic%20architecture%20elements%2C%20people%20gathering%20outside%2C%20warm%20lighting%2C%20community%20atmosphere%2C%20realistic%20photography%20style&width=800&height=400&seq=news1&orientation=landscape',
          excerpt: 'مركز ثقافي جديد مخصص للجالية المغاربية يفتح أبوابه في حي الضفة اليسرى.',
          content: `
            <p>تحتفل الجالية المغاربية في روان اليوم بالافتتاح المنتظر للمركز الثقافي الجديد الواقع في قلب حي الضفة اليسرى. هذا المشروع، الذي تحمله جمعية ولد بلادي منذ أكثر من عامين، يمثل مكان تجمع وتبادل حقيقي لكامل الجالية.</p>
            
            <h3>مساحة متعددة الاستخدامات في خدمة الجالية</h3>
            <p>يقدم المركز، بمساحة 500 متر مربع، العديد من المساحات المخصصة للأنشطة الثقافية والتعليمية والاجتماعية. نجد فيه خاصة:</p>
            <ul>
              <li>قاعة مؤتمرات تتسع لـ 100 شخص</li>
              <li>ثلاث قاعات دراسية لتعلم اللغة العربية</li>
              <li>مساحة مكتبة تضم أكثر من 1000 كتاب</li>
              <li>مطبخ جماعي للفعاليات</li>
              <li>صالون شاي تقليدي</li>
            </ul>
            
            <h3>أنشطة متنوعة لجميع الأعمار</h3>
            <p>برنامج أنشطة المركز غني ومتنوع. يمكن للأطفال المشاركة في دروس اللغة العربية والخط والموسيقى التقليدية. سيحصل البالغون على تدريب مهني ودروس فرنسية وورش إدماج.</p>
            
            <p>ينظم المركز أيضاً فعاليات ثقافية منتظمة: أمسيات شعرية، حفلات موسيقى أندلسية عربية، معارض فن مغاربي معاصر ومحاضرات حول تاريخ وثقافة المغرب العربي.</p>
            
            <h3>مشروع ممول بالتضامن</h3>
            <p>تمكن هذا المشروع من رؤية النور بفضل التعبئة الاستثنائية للجالية. ساهمت أكثر من 200 عائلة في التمويل، وشارك العديد من المتطوعين في أعمال التهيئة.</p>
            
            <p>قدمت مدينة روان ومنطقة نورماندي أيضاً دعمهما المالي، معترفتين بأهمية هذا المشروع للعيش المشترك والاندماج.</p>
            
            <h3>المواعيد والتسجيل</h3>
            <p>المركز مفتوح من الاثنين إلى السبت من 9 صباحاً إلى 10 مساءً، والأحد من 2 ظهراً إلى 8 مساءً. التسجيل في الأنشطة المختلفة مفتوح الآن في استقبال المركز أو على منصة ولد بلادي.</p>
          `
        },
        '2': {
          title: 'برنامج التدريب المهني للجالية',
          date: '12 ديسمبر 2024',
          author: 'خدمة التدريب',
          category: 'تدريب',
          image: 'https://readdy.ai/api/search-image?query=Professional%20training%20classroom%20with%20diverse%20North%20African%20students%20learning%20computer%20skills%2C%20modern%20equipment%2C%20instructor%20teaching%2C%20bright%20educational%20environment%2C%20realistic%20photography&width=800&height=400&seq=news2&orientation=landscape',
          excerpt: 'إطلاق برنامج تدريبي جديد في مهن الرقمنة مصمم خصيصاً لجاليتنا.',
          content: `
            <p>في إطار مهمتنا لمرافقة الوصول للعمل، تطلق ولد بلادي برنامج تدريب مهني طموح في مهن الرقمنة. تهدف هذه المبادرة للاستجابة للاحتياجات المتزايدة لسوق العمل المحلي مع تثمين مهارات جاليتنا.</p>
            
            <h3>تدريبات متكيفة مع احتياجات السوق</h3>
            <p>يقترح البرنامج أربعة مسارات تدريبية:</p>
            <ul>
              <li><strong>تطوير المواقع</strong>: HTML, CSS, JavaScript, React (6 أشهر)</li>
              <li><strong>صيانة المعلوماتية</strong>: إصلاح وتجميع الحاسوب (3 أشهر)</li>
              <li><strong>التجارة الإلكترونية</strong>: التجارة الإلكترونية، الشبكات الاجتماعية (4 أشهر)</li>
              <li><strong>المكتبيات المتقدمة</strong>: Office، المحاسبة (شهران)</li>
            </ul>
            
            <h3>مرافقة شخصية</h3>
            <p>يستفيد كل مشارك من متابعة فردية مع مستشار مخصص. الفريق التعليمي، المكون من محترفين ذوي خبرة من الجالية، يضمن تعليماً عالي الجودة في بيئة داعمة.</p>
            
            <p>تُقدم الدروس بالفرنسية مع إمكانية الترجمة للعربية لتسهيل فهم المفاهيم التقنية المعقدة.</p>
            
            <h3>شراكات مع الشركات المحلية</h3>
            <p>أقمنا شراكات مع أكثر من 30 شركة في روان تلتزم بتوظيف متدربينا. تشارك هذه الشركات أيضاً في وضع البرامج لضمان ملاءمتها مع الاحتياجات الحقيقية للسوق.</p>
            
            <h3>شروط التسجيل</h3>
            <p>التدريبات مجانية ومفتوحة لجميع أعضاء الجالية من سن 18 إلى 55 سنة. التسجيل يتم عبر مقابلة دافعية واختبار مستوى. جلسة التسجيل القادمة: 8 يناير 2025.</p>
          `
        },
        '3': {
          title: 'السوق التضامني الأسبوعي: نجاح متزايد',
          date: '10 ديسمبر 2024',
          author: 'لجنة التنظيم',
          category: 'تضامن',
          image: 'https://readdy.ai/api/search-image?query=Vibrant%20weekly%20market%20with%20North%20African%20vendors%20selling%20traditional%20foods%2C%20spices%2C%20crafts%2C%20families%20shopping%20together%2C%20colorful%20stalls%2C%20community%20atmosphere%2C%20Rouen%20France%2C%20realistic%20photography&width=800&height=400&seq=news3&orientation=landscape',
          excerpt: 'السوق التضامني يوم السبت يجذب المزيد من العائلات ويقوي الروابط المجتمعية.',
          content: `
            <p>منذ إطلاقه قبل ستة أشهر، يشهد السوق التضامني الأسبوعي المنظم من قبل ولد بلادي نجاحاً متزايداً. كل صباح سبت، تتحول ساحة السوق القديم إلى ملتقى حقيقي للتبادل والتضامن لجاليتنا.</p>
            
            <h3>أكثر من سوق، مكان للحياة</h3>
            <p>يجمع السوق التضامني اليوم أكثر من 40 كشكاً تديرها عائلات من الجالية. نجد فيه:</p>
            <ul>
              <li>منتجات غذائية تقليدية من المغرب العربي</li>
              <li>توابل وبهارات مستوردة مباشرة</li>
              <li>حرف تقليدية (فخار، نسيج، مجوهرات)</li>
              <li>منتجات تجميل طبيعية</li>
              <li>خدمات إصلاح وخياطة</li>
            </ul>
            
            <h3>نظام تعاون فريد</h3>
            <p>يعمل السوق وفق مبدأ التضامن: 20% من الأرباح تُحول لصندوق مشترك يساعد العائلات المتعثرة. هذا النظام يسمح بدعم أعضاء الجالية عملياً مع تثمين ريادة الأعمال المحلية.</p>
            
            <p>بالإضافة لذلك، تم وضع نظام مقايضة: يمكن للعائلات تبادل الخدمات مقابل المنتجات، مما يقوي روابط التعاون.</p>
            
            <h3>الأثر الاقتصادي والاجتماعي</h3>
            <p>في ستة أشهر، حقق السوق أكثر من 50,000 يورو من رقم الأعمال للبائعين، مما سمح للعديد من العائلات بتحسين وضعها المالي. تم إنشاء أكثر من 15 مشروعاً صغيراً بفضل هذه المبادرة.</p>
            
            <p>وراء الجانب الاقتصادي، أصبح السوق مكان تواصل حقيقي حيث تنسج صداقات جديدة وتتقوى الروابط بين الأجيال.</p>
            
            <h3>مشاريع التوسع</h3>
            <p>أمام النجاح المحقق، ندرس إمكانية تنظيم سوق ثان في الأسبوع وتوسيع المبادرة لأحياء أخرى في روان. سوق متخصص في المنتجات العضوية والعادلة قيد الدراسة أيضاً.</p>
          `
        }
      }
    }
  };

  const currentTexts = newsData[language as keyof typeof newsData];
  const currentArticle = currentTexts.articles[id as keyof typeof currentTexts.articles];

  if (!currentArticle) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="max-w-4xl mx-auto px-4 py-16 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Article non trouvé</h1>
          <Link to="/" className="text-emerald-600 hover:text-emerald-700 cursor-pointer">
            {currentTexts.backToHome}
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Language Switcher */}
        <div className="flex justify-center mb-8">
          <div className="flex items-center bg-white rounded-lg p-1 shadow-sm">
            <button
              onClick={() => setLanguage('fr')}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer whitespace-nowrap ${
                language === 'fr' ? 'bg-emerald-600 text-white shadow-md' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              FR
            </button>
            <button
              onClick={() => setLanguage('ar')}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer whitespace-nowrap ${
                language === 'ar' ? 'bg-emerald-600 text-white shadow-md' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              العربية
            </button>
          </div>
        </div>

        {/* Breadcrumb */}
        <nav className={`mb-8 ${language === 'ar' ? 'text-right' : ''}`}>
          <Link to="/" className="text-emerald-600 hover:text-emerald-700 cursor-pointer">
            {currentTexts.backToHome}
          </Link>
          <span className="mx-2 text-gray-400">/</span>
          <span className="text-gray-600">{currentTexts.title}</span>
        </nav>

        {/* Article Header */}
        <header className={`mb-8 ${language === 'ar' ? 'text-right' : ''}`}>
          <div className="mb-4">
            <span className="inline-block px-3 py-1 bg-emerald-100 text-emerald-800 text-sm font-medium rounded-full">
              {currentArticle.category}
            </span>
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
            {currentArticle.title}
          </h1>
          
          <div className="flex items-center text-gray-600 text-sm mb-6">
            <span>{currentTexts.publishedOn} {currentArticle.date}</span>
            <span className="mx-2">•</span>
            <span>{currentTexts.by} {currentArticle.author}</span>
          </div>
          
          <img
            src={currentArticle.image}
            alt={currentArticle.title}
            className="w-full h-64 object-cover rounded-lg shadow-lg"
          />
        </header>

        {/* Article Content */}
        <article className={`prose prose-lg max-w-none mb-12 ${language === 'ar' ? 'text-right' : ''}`}>
          <div 
            className="text-gray-700 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: currentArticle.content }}
          />
        </article>

        {/* Share Section */}
        <div className={`border-t border-gray-200 pt-8 mb-12 ${language === 'ar' ? 'text-right' : ''}`}>
          <h3 className="text-lg font-semibold text-gray-900 mb-4">{currentTexts.shareArticle}</h3>
          <div className="flex space-x-4">
            <button className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-facebook-fill mr-2"></i>
              Facebook
            </button>
            <button className="flex items-center px-4 py-2 bg-sky-500 text-white rounded-lg hover:bg-sky-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-twitter-fill mr-2"></i>
              Twitter
            </button>
            <button className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-fill mr-2"></i>
              WhatsApp
            </button>
          </div>
        </div>

        {/* Related Articles */}
        <section className={`border-t border-gray-200 pt-8 ${language === 'ar' ? 'text-right' : ''}`}>
          <h3 className="text-2xl font-bold text-gray-900 mb-6">{currentTexts.relatedNews}</h3>
          <div className="grid md:grid-cols-2 gap-6">
            {Object.entries(currentTexts.articles)
              .filter(([articleId]) => articleId !== id)
              .slice(0, 2)
              .map(([articleId, article]) => (
                <Link
                  key={articleId}
                  to={`/news/${articleId}`}
                  className="group bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
                >
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="p-6">
                    <div className="mb-2">
                      <span className="inline-block px-2 py-1 bg-emerald-100 text-emerald-800 text-xs font-medium rounded">
                        {article.category}
                      </span>
                    </div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                      {article.title}
                    </h4>
                    <p className="text-gray-600 text-sm mb-3">{article.excerpt}</p>
                    <div className="text-xs text-gray-500">{article.date}</div>
                  </div>
                </Link>
              ))}
          </div>
        </section>

        {/* Back to News */}
        <div className="text-center mt-12">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            {currentTexts.readMore}
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NewsPage;
